import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator';
import distance from '@blade-sxp/monitor/pages/main/record-center/components/task/diatance.vue';
import faceRadio from '@blade-sxp/monitor/pages/main/record-center/components/task/face-radio.vue';
import InvisibleNumber from '@blade/common/components/invisible-number.vue';
import alarmDetails from '../alarm-details/index.vue';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import moment from 'moment';
import { getAllTaskList } from '@blade-sxp/monitor-center/api/index';
import { EventBus } from '@blade/common';
import { getAlarmList } from '@blade/common/api/alarm-center';
import colors from '@/styles/color.scss';
import { AlarmDetailsModule } from '@blade/common/store/alarm-details';
import imagesBox from '@blade-sxp/monitor-center/pages/components/msg-alarm/images-box.vue';
let default_1 = class default_1 extends Vue {
    msgDraw;
    msgList;
    viewMsgList;
    jumpDialog;
    matchThresh;
    activeBorderColor = colors.borderItemHover;
    drawer = false;
    listLength = 0;
    crowdList = [];
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    faceDialog = false;
    taskConfig;
    Roi;
    dialogItem;
    size = '355px';
    messageSwitch = false;
    dialogVisible = false;
    timer = NaN;
    delayTime = 5000; // 定时弹框的延迟时间；
    isDelay = false;
    isFirstTimer = true; // 是否第一次更新
    isMsgUpdate = false; // msgList是否更新\
    isClickClose = false;
    taskList = [];
    updateStatus = '';
    details = {
        alertTime: '',
        level: '',
        deviceId: '',
        deviceName: '',
        name: '',
        incidentStatus: '',
        incidentType: '',
        id: '',
        panoramicImage: '',
        remarks: [],
        resolveStatus: '',
        status: '',
        tenantId: '',
        taskConsist: {
            zoneId: '',
            zoneName: '',
            taskId: '',
            taskName: '',
            taskType: '',
            remark: '',
        },
        treePathName: [],
        crowdAnnotation: undefined,
        commonAnnotation: undefined,
        pedestrianAnnotation: undefined,
        faceAnnotation: undefined,
        trafficAnnotation: undefined,
        foldsTotal: 0,
        favorite: null,
        favoritesInfos: null,
    };
    showRecordDetail = false;
    tipsShow = false;
    alarmFilter = false;
    showMsgList = [];
    showMsgListIds = [];
    form = {
        taskList: [],
    };
    isBlur = localStorage.getItem('privacyMode') === 'true';
    get getPrivacyMode() {
        return this.privacyMode === 'true' ? 6 : 0;
    }
    getShowMsgList() {
        return this.msgList
            .filter((item) => {
            return this.form.taskList.indexOf(item.taskConsist.taskId.toString()) !== -1;
        })
            .slice(0, 30);
    }
    get newViewNow() {
        return this.viewMsgList.length;
    }
    libraryName(item) {
        let str = '';
        if (item.faceAnnotation || item.pedestrianAnnotation || item.automobileAnnotation) {
            str = item.faceAnnotation
                ? item.faceAnnotation.libraryName
                : item.pedestrianAnnotation
                    ? item.pedestrianAnnotation.libraryName
                    : item.automobileAnnotation.libraryName;
            return str;
        }
        if (item.taskConsist) {
            str = item.taskConsist.taskName;
            return str;
        }
    }
    onViewMsgListChange(newVal) {
        this.tipsShow = !!newVal.length;
    }
    onTaskListChange() {
        const arr = [];
        this.taskList.forEach((e) => {
            if (!this.form.taskList.includes(e.id)) {
                arr.push(e.id);
            }
        });
        sessionStorage.setItem('disable-alert-task', JSON.stringify(arr));
        this.showMsgList = this.getShowMsgList();
    }
    onTaskChange(item) {
        if (!item.checked) {
            item.recieveAlert = false;
            this.onSwitchChange(item);
        }
        this.form.taskList = this.taskList.filter((e) => e.checked).map((e) => e.id);
    }
    onSwitchChange(item) {
        const recieveAlerts = this.taskList.filter((e) => e.recieveAlert).map((e) => e.id);
        sessionStorage.setItem('active-recieve-alert', JSON.stringify(recieveAlerts));
    }
    getTaskList() {
        const params = {
            taskTypes: [],
            onlyAlert: true,
        };
        getAllTaskList(params).then((res) => {
            if (res)
                this.taskList = res;
            const recieveAlerts = (sessionStorage.getItem('active-recieve-alert') && JSON.parse(sessionStorage.getItem('active-recieve-alert'))) || [];
            const disableChecked = (sessionStorage.getItem('disable-alert-task') && JSON.parse(sessionStorage.getItem('disable-alert-task'))) || [];
            this.taskList.forEach((e) => {
                // e.recieveAlert = false;
                // e.checked = true;
                this.$set(e, 'recieveAlert', false);
                this.$set(e, 'checked', true);
                if (recieveAlerts.includes(e.id))
                    e.recieveAlert = true;
                if (disableChecked.includes(e.id))
                    e.checked = false;
            });
            this.form.taskList = this.taskList.filter((e) => e.checked).map((e) => e.id);
        });
    }
    onMsgListChange(newVal) {
        // 获取筛选数据
        const list = this.getShowMsgList();
        this.showMsgList = [...list];
        // 最新任务id
        const ids = [];
        let isUpdate = false;
        list.forEach((item) => {
            const id = item?.id ?? '';
            // 比对之前的任务id,不存在则是新增任务id,展示数据更新
            if (id && this.showMsgListIds.indexOf(id) === -1)
                isUpdate = true;
            ids.push(item?.id);
        });
        this.showMsgListIds = ids;
        // 数据更新
        this.isMsgUpdate = isUpdate;
    }
    onShowMsgListChange(newVal) {
        if (!this.dialogVisible && this.jumpDialog && this.isFirstTimer && this.isMsgUpdate) {
            // const isUpdate =  this.showMsgListIds
            // 不是点击关闭按钮或者已经超时了才推送数据立即显示
            (!this.isClickClose || !this.isDelay) && this.showDialog(this.showMsgList[0]);
        }
    }
    onUpdateList(data) {
        return data;
    }
    onMessageSwitchChange(newVal) {
        // this.$emit('changeBadgeShow', newVal);
        this.isClickClose = !newVal;
        localStorage.setItem('messageSwitch', newVal.toString());
    }
    created() {
        this.getTaskList();
    }
    darwClear() {
        this.$emit('darwClear');
    }
    handleViewNow() {
        this.tipsShow = false;
        this.$emit('getViewNow');
    }
    closeDialog() {
        this.dialogVisible = false;
        this.isClickClose = true;
        this.isDelay = true;
        this.timer && clearTimeout(this.timer);
        this.timer = NaN;
        this.delayOpenDialog();
    }
    confirmDialog(data) {
        this.dialogVisible = false;
        this.isClickClose = false;
        if (data?.status === 'DELETE') {
            this.closeDialog();
        }
        if (data && data.id) {
            this.updateStatus = data.status;
            this.onUpdateList(data);
        }
    }
    updateDialog() {
        const param = {
            page: 1,
            size: 100,
            dateEnd: '',
            dateStart: '',
            keyWord: '',
            alertLevel: null,
            deviceIds: [],
            incidentStatus: null,
            incidentTypes: null,
            favorite: null,
            recordIds: this.details.id ? [this.details.id] : null,
        };
        getAlarmList(param).then((res) => {
            this.details = res.list[0];
        });
    }
    showDialog(item, jump = false) {
        this.details = {
            ...item,
        };
        const taskId = item.taskConsist.taskId.toString();
        const task = this.taskList.find((e) => e.id === taskId);
        // 如果没有选中告警则跳转，否则弹窗
        if (task?.recieveAlert) {
            this.dialogVisible = true;
            this.isMsgUpdate = false;
            AlarmDetailsModule.updateDetailsData(this.details);
        }
        else if (jump) {
            // this.$router.push({
            //   path: '/alarmCenter',
            //   query: {
            //     id: item.id,
            //   },
            // });
            window.open(this.$router.resolve({
                path: '/alarmCenter',
                query: {
                    recordIds: item.id,
                },
            }).href, '_blank');
            this.$nextTick(() => {
                EventBus.$emit('ALERT_DETAIL', item);
            });
        }
    }
    delayOpenDialog() {
        /*
         * messageSwitch: 是否允许告警消息推送
         * dialogVisible: 是否弹框
         * isDelay：是否延迟
         * msgList： 消息数据源
         * isMsgUpdate： 数据是否更新，若没更新不显示
         * isClickClose：是否点击的close按钮，dian
         * */
        this.timer = setTimeout(() => {
            this.isDelay = false;
            // 进入5s延迟推送状态，若没有推送则不再推送，若5s内有推送不显示，5s后有推送则立即显示
            if (!this.messageSwitch || this.dialogVisible || !(this.msgList.length > 0) || !this.isMsgUpdate || !this.isClickClose)
                return;
            this.details = {
                ...this.showMsgList[0],
            };
            this.dialogVisible = true;
            this.isMsgUpdate = false;
            this.isClickClose = false;
        }, this.delayTime);
    }
    formatTime(time) {
        if (!time)
            return '';
        return moment(parseInt(time)).format('yyyy-MM-DD HH:mm:ss');
    }
    // getDetailsIncidentType(val: any) {
    //   let newText: string = '';
    //   if (val.dateDiff && val.dateDiff > 0) {
    //     newText = this.$t('lastedTime', { num: formatTime(val.dateDiff.toString()) }).toString();
    //   }
    //   return newText;
    // }
    getTextIncidentType(val) {
        let text = '';
        switch (val) {
            case 'INCIDENT_CROWD':
                text = this.$t('incidentCrowd').toString();
                break;
            case 'INCIDENT_QUEUE_TIMING':
                text = this.$t('incidentQueueTiming').toString();
                break;
            case 'INCIDENT_QUEUE_COUNTING':
                text = this.$t('incidentQueueCounting').toString();
                break;
            case 'INCIDENT_OFF_DUTY':
                text = this.$t('incidentOffDuty').toString();
                break;
            case 'INCIDENT_STRAND':
                text = this.$t('crowdRetention').toString();
                break;
            case 'INCIDENT_RETROGRADE':
                text = this.$t('crowdCounterflow').toString();
                break;
            case 'INCIDENT_INVADE':
                text = this.$t('crowdIntrusion').toString();
                break;
            case 'INCIDENT_SOCIAL_DISTANCE':
                text = this.$t('closeSocialDistance').toString();
                break;
            case 'INCIDENT_CONGREGATE':
                text = this.$t('crowdGatherAndDispersion').toString();
                break;
            case 'INCIDENT_SCATTER':
                text = this.$t('crowdScatter').toString();
                break;
            case 'FACE_MATCH':
                text = this.$t('faceComparison').toString();
                break;
            case 'FACE_PEDESTRIAN':
                text = this.$t('faceBodyRecognition').toString();
                break;
        }
        return text;
    }
    getPortraitImage(val) {
        return val.portraitImage || val.vehicleImage;
    }
    getThreshold(val) {
        return (val * 100).toFixed(2) + '%';
    }
    getPortraitCaptureImage(val) {
        return val.portraitCaptureImage;
    }
    goAll() {
        this.closedialogs();
        // this.darwClear();
    }
    closedialogs() {
        this.faceDialog = false;
        this.showRecordDetail = false;
    }
    handleAlarmCenter() {
        let newUrl = this.$router.resolve({
            path: '/alarmCenter',
        });
        window.open(newUrl.href, '_blank');
    }
    getDeviceName(deviceName) {
        const arr = deviceName.split('/');
        return arr[arr.length - 1];
    }
    getFrequencyDay(item) {
        return item?.faceAnnotation?.frequencyDay
            ? item.faceAnnotation.frequencyDay + this.$t('day') + item.faceAnnotation.frequencyCount + this.$t('times')
            : '';
    }
    beforDestroyed() {
        this.timer && clearTimeout(this.timer);
        this.timer = NaN;
    }
};
__decorate([
    Prop()
], default_1.prototype, "msgDraw", void 0);
__decorate([
    Prop()
], default_1.prototype, "msgList", void 0);
__decorate([
    Prop()
], default_1.prototype, "viewMsgList", void 0);
__decorate([
    Prop()
], default_1.prototype, "jumpDialog", void 0);
__decorate([
    Watch('viewMsgList')
], default_1.prototype, "onViewMsgListChange", null);
__decorate([
    Watch('form.taskList')
], default_1.prototype, "onTaskListChange", null);
__decorate([
    Watch('msgList')
], default_1.prototype, "onMsgListChange", null);
__decorate([
    Watch('showMsgList')
], default_1.prototype, "onShowMsgListChange", null);
__decorate([
    Emit('updateList')
], default_1.prototype, "onUpdateList", null);
__decorate([
    Emit('changeBadgeShow')
], default_1.prototype, "onMessageSwitchChange", null);
default_1 = __decorate([
    Component({
        name: 'MsgBoard',
        components: {
            distance,
            faceRadio,
            InvisibleNumber,
            alarmDetails,
            BlurPicture,
            imagesBox,
        },
        i18n: {
            messages: {
                'en-us': {
                    switchOpenContent: 'Open the alert popup',
                    switchCloseContent: 'Close the alert popup',
                    totalPeople: 'total people',
                    overLimitRatio: 'Over-limit ratio',
                    name: 'Name',
                    position: 'position',
                    regionalInvasion: 'Regional invasion',
                    faceControlRatio: 'Facial Matched Result',
                    overflowOfPeople: 'Overflow of people',
                    crowded: 'Crowded',
                    crowdgathering: 'Crowd gathering',
                    crowdSpreadOut: 'Crowd spread out',
                    crowdCountercurrent: 'Crowd countercurrent',
                    distanceTooClose: 'Social distance too close',
                    missionName: 'Task Name',
                    taskType: 'Task type',
                    deviceName: 'Device Name',
                    triggerTime: 'Created Time',
                    threshold: 'Threshold',
                    portraitLibrary: 'Portrait Library',
                    idPicture: 'ID Photo',
                    liveAvatar: 'Live Avatar',
                    numberThreshold: 'Threshold Number of People',
                    detentionTimeThreshold: 'Loitering Time Threshold',
                    currentNumber: 'Current number',
                    LengthOfStay: 'Length of stay',
                    people: 'people',
                    direction: 'Statistical direction',
                    statisticalTime: 'Statistical time',
                    overrunThreshold: 'Overrun threshold',
                    statistics: 'Statistics',
                    crossLine: 'Cross line direction indicator',
                    area: 'Area',
                    numberOfpeople: 'Number of people',
                    crowdDensity: 'Crowd density',
                    distanceThreshold: 'Distance threshold',
                    durationThreshold: 'Duration threshold',
                    distance: 'Distance',
                    duration: 'duration',
                    alarmMethod: 'Alarm method',
                    numberOfUpstream: 'Number of upstream',
                    socialDistance: 'Social distance threshold',
                    positiveDirection: 'Positive direction indicator',
                    heatMap: 'Heat map',
                    warningCrowded: 'Overcrowding Alert',
                    warningRegional: 'Regional intrusion warning',
                    warningReflux: 'Crowd reflux warning',
                    systemList: 'Alert Notification',
                    viewAll: 'view more',
                    noData: 'No New Alert',
                    critical: 'Critical',
                    major: 'Major',
                    minor: 'Minor',
                    incidentCrowd: 'Crowd Counting',
                    incidentQueueTiming: 'Queue Timing',
                    incidentQueueCounting: 'Queue Counting',
                    incidentOffDuty: 'Unauthorized Leave',
                    crowdRetention: 'Crowd Retention',
                    crowdCounting: 'Crowd Counting',
                    crowdCounterflow: 'Crowd Counterflow',
                    crowdIntrusion: 'Crowd Intrusion',
                    closeSocialDistance: 'Close Social Distance',
                    crowdGatherAndDispersion: 'Crowd Gather',
                    crowdScatter: 'Crowd Dispersion',
                    faceComparison: 'Face Comparison',
                    faceBodyRecognition: 'Face & Body Recognition',
                    progress: '{progressNum} in progress，{totalNum} alerts in total',
                    results: '{results} Results',
                    incidentType: '{type} ({num})',
                    lastedTime: '{num} ago',
                    viewAllalerts: 'View All Alerts',
                    textTipsShow: '{num} new notifications，',
                    viewNow: 'view now',
                    inputHolder: 'Task Name ',
                    filterPushesAndPopups: 'Filter pushes and popups',
                    day: 'day',
                    times: 'times',
                },
                zh: {
                    switchOpenContent: '打开弹窗',
                    switchCloseContent: '关闭弹窗',
                    inputHolder: '请输入任务名称',
                    totalPeople: '总人数',
                    overLimitRatio: '超限比例',
                    name: '姓名',
                    position: '位置',
                    regionalInvasion: '区域入侵',
                    faceControlRatio: '人脸布控比中',
                    overflowOfPeople: '人流量超限',
                    crowded: '人群过密',
                    crowdgathering: '人群聚集',
                    crowdSpreadOut: '人群散开',
                    crowdCountercurrent: '人群逆流',
                    distanceTooClose: '社交距离过近',
                    missionName: '任务名称',
                    taskType: '任务类型',
                    deviceName: '设备名称',
                    triggerTime: '触发时间',
                    threshold: '阈值',
                    portraitLibrary: '人像库',
                    idPicture: '证件头像',
                    liveAvatar: '现场头像',
                    numberThreshold: '人数阈值',
                    detentionTimeThreshold: '滞留时长阈值',
                    currentNumber: '当前人数',
                    LengthOfStay: '滞留时长',
                    people: '人',
                    direction: '统计方向',
                    statisticalTime: '统计时长',
                    overrunThreshold: '超限阈值',
                    statistics: '统计人数',
                    crossLine: '跨线方向标识',
                    area: '区域面积',
                    numberOfpeople: '人数',
                    crowdDensity: '人群密度',
                    distanceThreshold: '距离阈值',
                    durationThreshold: '时长阈值',
                    distance: '距离',
                    duration: '时长',
                    alarmMethod: '告警方式',
                    numberOfUpstream: '逆流人数',
                    socialDistance: '社交距离阈值',
                    positiveDirection: '正方向标识',
                    heatMap: '热力图',
                    warningCrowded: '人群过密告警',
                    systemList: '告警消息推送',
                    viewAll: '查看全部',
                    noData: '没有新告警',
                    critical: '重度',
                    major: '中度',
                    minor: '轻度',
                    incidentCrowd: '人群统计',
                    incidentQueueTiming: '排队时长',
                    incidentQueueCounting: '排队人数',
                    incidentOffDuty: '离岗检测',
                    crowdRetention: '人群滞留',
                    crowdCounting: '人群计数',
                    crowdCounterflow: '人群逆流',
                    crowdIntrusion: '人群入侵',
                    closeSocialDistance: '社交距离过近',
                    crowdGatherAndDispersion: '人群聚集',
                    crowdScatter: '人群分散',
                    faceComparison: '人脸比对',
                    faceBodyRecognition: '人脸&人体识别',
                    progress: '告警中 {progressNum} 条，总共 {totalNum} 条',
                    results: '{results} 条',
                    incidentType: '{type} ({num})',
                    lastedTime: '{num}前',
                    viewAllalerts: '查看更多',
                    textTipsShow: '已接收新的告警 {num} 条，',
                    viewNow: '查看',
                    filterPushesAndPopups: '过滤器推送和弹出',
                    day: '天出现',
                    times: '次',
                },
            },
        },
    })
], default_1);
export default default_1;
